import { Route } from '@angular/router';
import { groupAdminGuard } from '../../../services/group-admin.guard';

/**
 * Campaign screens, used in both the church (/groups) and school (/school) trees. Admins only;
 * school presidents and principals count as admins. Lazy-loaded so the designer's editor
 * (Tiptap) never reaches the main bundle.
 */
export const CAMPAIGN_ROUTE: Route = {
  path: ':id/campaigns',
  canActivate: [groupAdminGuard],
  children: [
    {
      path: '',
      title: 'Campaigns',
      loadComponent: () => import('./list-campaigns/list-campaigns.component').then((m) => m.ListCampaignsComponent),
    },
    {
      path: 'sending',
      title: 'Sending Domain',
      loadComponent: () => import('./sending-domain/sending-domain.component').then((m) => m.SendingDomainComponent),
    },
    {
      path: ':campaignId',
      title: 'Campaign',
      loadComponent: () => import('./campaign-designer/campaign-designer.component').then((m) => m.CampaignDesignerComponent),
    },
  ],
};
